import Image, { type ImageProps } from 'next/image';
import { type FC } from 'react';

import { getPublicGraphicPath } from '@/src/config';

export type IllustrationVariant =
  | 'analytics'
  | 'broken'
  | 'build'
  | 'calendar'
  | 'deadline'
  | 'delete-trash'
  | 'directions'
  | 'education'
  | 'good-job'
  | 'hi'
  | 'high-five'
  | 'inbox'
  | 'launch'
  | 'location-map'
  | 'message-notification'
  | 'mobile-life'
  | 'notifications'
  | 'pet'
  | 'photos-and-media'
  | 'picture-art'
  | 'security'
  | 'send-email'
  | 'travel'
  | 'travel-international'
  | 'work-at-home';

export interface IllustrationDisplayProps {
  readonly altText?: ImageProps['alt'];
  readonly height?: ImageProps['height'];
  readonly variant: IllustrationVariant;
  readonly width?: ImageProps['width'];
}

/**
 * @deprecated
 * Please use the 'Image' component from '@/src/components-v2/images/Image.tsx' instead.
 */
export const IllustrationDisplay: FC<IllustrationDisplayProps> = ({
  altText,
  height = 400,
  variant,
  width = 400,
}) => (
  <Image
    alt={altText ?? variant}
    height={height}
    src={getPublicGraphicPath(`${variant}.png`)}
    width={width}
  />
);
